export default {
  BackgroundSettings: "Arka Plan Ayarları",
  ResetValues: "Değerleri Sıfırla",
  BackgroundSigmaSpace: "Örnekleme Uzaklığı",
  CoverageMin: "Minimum Kapsama",
  CoverageMax: "Maksimum Kapsama",
  LightWrapping: "Kenar parlaklığı",
};
